export const BLOCK_TYPE_BANNER = 'Banner'
export const BLOCK_TYPE_CALL_TO_ACTION = 'Link4'
export const BLOCK_TYPE_PRODUCT_LIST = 'ProductCarousel'
export const BLOCK_TYPE_PROMO = 'Promo'
export const BLOCK_TYPE_WYSIWYG = 'WYSIWYG'
